import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";

const UpdateClientProductForm = ({ product, onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup
      .string()
      .required(
        t("clients.detail.tabs.products.updateForm.fields.code.required"),
      ),
    name: yup
      .string()
      .required(
        t("clients.detail.tabs.products.updateForm.fields.name.required"),
      ),
  });

  const defaultValues = {
    category: product?.category?.name,
    code: product?.code,
    name: product?.name,
    description: product?.description,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <FormInput
        name="category"
        label={t(
          "clients.detail.tabs.products.updateForm.fields.category.label",
        )}
        disabled={true}
        required
      />
      <FormInput
        name="code"
        label={t("clients.detail.tabs.products.updateForm.fields.code.label")}
        required
      />
      <FormInput
        name="name"
        label={t("clients.detail.tabs.products.updateForm.fields.name.label")}
        required
      />
      <FormInput
        name="description"
        label={t(
          "clients.detail.tabs.products.updateForm.fields.description.label",
        )}
      />
    </BaseForm>
  );
};

export default UpdateClientProductForm;
